export function StickyNavigation() {
    document.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    function checkScroll() {
        if (window.pageYOffset > 90) {
            document.body.classList.add('nav-sticky');
        } else {
            document.body.classList.remove('nav-sticky');
        }
    }
    checkScroll();
}
